import { Navigate } from "react-router-dom";

/** En turneroApp las sub-vistas de paciente son funciones premium. */
export default function PacienteSubview() {
  return <Navigate to="/premium" replace />;
}
